import React, { useState } from "react";
import { apiClient } from "../services/api";
import { useNavigate } from "react-router-dom";

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!username || !password) {
      setError("ID와 비밀번호를 입력하세요.");
      return;
    }

    setLoading(true);
    try {
      const response = await apiClient.login(username, password);
      apiClient.setToken(response.access_token);
      navigate(response.role === "admin" || response.role === "teacher" ? "/student" : "/viewer");
    } catch (e) {
      setError("로그인 실패: 아이디 또는 비밀번호를 확인하세요.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div style={{ width: "320px", margin: "120px auto" }}>
      <h2>로그인</h2>
      <input
        value={username}
        onChange={e => setUsername(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="ID"
        style={{ width: "100%", marginBottom: "10px", padding: "8px", boxSizing: "border-box" }}
      />
      <input
        value={password}
        type="password"
        onChange={e => setPassword(e.target.value)}
        onKeyPress={handleKeyPress}
        placeholder="비밀번호"
        style={{ width: "100%", marginBottom: "10px", padding: "8px", boxSizing: "border-box" }}
      />
      <button 
        onClick={handleLogin}
        disabled={loading}
        style={{ width: "100%", marginBottom: "10px", padding: "8px", cursor: loading ? "not-allowed" : "pointer" }}>
        {loading ? "로그인 중..." : "로그인"}
      </button>
      {error && <div style={{ color: "red", marginTop: "16px" }}>{error}</div>}

      {/* Google 로그인 버튼 */}
      <div style={{ marginTop: "16px", textAlign: "center" }}>
        <button
          onClick={() => {
            // 비로그인 상태 Google OAuth: state 없이 시작
            window.location.href = `${process.env.REACT_APP_API_URL || 'http://localhost:3001'}/api/auth/google`;
          }}
          style={{
            width: "100%",
            padding: "10px",
            borderRadius: 6,
            border: "1px solid #ddd",
            background: "#fff",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 8,
          }}
          aria-label="구글 계정으로 로그인"
          title="구글 계정으로 로그인"
        >
          <span style={{ fontSize: 16 }}>🔵</span>
          <span>Google 계정으로 로그인</span>
        </button>
      </div>
    </div>
  );
}

export default LoginPage;